import { Component, DestroyRef, input, OnInit, inject } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Notary } from '@app/core/stingray-api/models';
import { finalize } from 'rxjs/operators';
import { requireMatch } from '@app/validators/autocomplete-validator';
import { NotaryAutoCompleteService } from './notary-autocomplete.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatListItem } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';


@Component({
    selector: 'unite-notary-autocomplete',
    templateUrl: './notary-autocomplete.component.html',
    styleUrls: ['./notary-autocomplete.component.scss'],
    imports: [MatFormField, MatLabel, MatIconButton, MatSuffix, MatIcon, MatProgressSpinner, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, TranslateModule, MatListItem]
})
export class NotaryAutocompleteComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  control = input<FormControl>();
  required = input(false);
  focus = input(false);
  label = input<string>();
  isMatListItem = input(false);

  notaries: Notary[] = [];
  notariesFiltered: Notary[];

  isLoadingNotaries = false;

  constructor(
    private notaryAutoCompleteService: NotaryAutoCompleteService) { }

  ngOnInit() {
    if (this.required() === false) {
      this.control().setValidators([requireMatch]);
    } else {
      this.control().setValidators([Validators.required, requireMatch]);
    }

    this.isLoadingNotaries = true;
    this.notaryAutoCompleteService.getNotaries()
      .pipe(
        finalize(() => this.isLoadingNotaries = false),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((customers: Notary[]) => {
        this.notaries = customers;
        this.notariesFiltered = customers;
      });
  }

  doFilter(value: string | Notary) {
    if (this.isNotary(value)) {
      this.notariesFiltered = this.filterNotary(value.name);
    } else {
      this.notariesFiltered = this.filterNotary(value || '');
    }
  }

  refreshNotaries() {
    this.isLoadingNotaries = true;
    this.notaryAutoCompleteService.getNotaries(true).pipe(
      finalize(() => {
        this.isLoadingNotaries = false;
      })
    ).subscribe((notaries: Notary[]) => {
      this.notaries = notaries;
      this.notariesFiltered = notaries;
    });
  }

  displayWithNotary(notary: Notary): string {
    if (notary != null) {
      return notary.name + ' - ' + notary.address.city;
    } else {
      return '';
    }
  }

  filterNotary(value: string): Notary[] {
    const filterValue = value.toLowerCase();
    return this.notaries.filter((notary: Notary) => {
      return this.displayWithNotary(notary).toLowerCase().includes(filterValue) ||
        notary.address.addressLine1.toLowerCase().includes(filterValue) ||
        notary.address.addressLine2.toLowerCase().includes(filterValue);
    });
  }

  isNotary(value: any | Notary): value is Notary {
    return value != null && (<Notary>value).id !== undefined;
  }
}
